<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.80005 2.2202V3.55351H3.13336M2.35782 4.66459C2.65382 5.50473 3.46976 6.04785 4.35905 5.99667C5.24834 5.94549 5.99659 5.31234 6.19424 4.44379C6.39189 3.57523 5.9913 2.68065 5.21173 2.24969C4.43216 1.81874 3.46154 1.9553 2.83114 2.58463L1.93094 3.43051"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.1554 3.4707V4.52263H5.11239"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
